module.exports = __webpack_public_path__ + "img/zip.8d5876ff.png";